export const APP_SOUND_VOLUME = 0.02;

const isIOS =
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

let iosAudioContext: AudioContext | null = null;

const getIOSAudioContext = () => {
  if (!iosAudioContext) {
    const AudioContextCtor =
      window.AudioContext ||
      (
        window as unknown as {
          webkitAudioContext: typeof AudioContext;
        }
      ).webkitAudioContext;
    iosAudioContext = new AudioContextCtor();
  }
  return iosAudioContext;
};

// iOS Safari ignores HTMLMediaElement.volume — route through GainNode instead.
const playWithGain = async (src: string) => {
  const audio = new Audio(src);
  audio.setAttribute("playsinline", "true");

  const ctx = getIOSAudioContext();
  if (ctx.state === "suspended") {
    await ctx.resume();
  }

  const source = ctx.createMediaElementSource(audio);
  const gain = ctx.createGain();
  gain.gain.value = APP_SOUND_VOLUME;
  source.connect(gain);
  gain.connect(ctx.destination);

  const cleanup = () => {
    try {
      source.disconnect();
      gain.disconnect();
    } catch {
      // already disconnected
    }
  };
  audio.addEventListener("ended", cleanup, { once: true });
  audio.addEventListener("error", cleanup, { once: true });

  return audio.play().catch((err) => {
    cleanup();
    throw err;
  });
};

export const playAppSound = (src: string) => {
  if (isIOS) {
    return playWithGain(src);
  }

  const audio = new Audio(src);
  audio.setAttribute("playsinline", "true");
  audio.volume = APP_SOUND_VOLUME;
  return audio.play();
};
